import VersionApi from '@apis/version/VersionApi';
import { VersionResponse } from '@models/version';
import { getVersion } from '@utils/nativeUtils';
import { useEffect } from 'react';

import useNativeListener from './useNativeListener';

interface Props {
    onUpdateRequired?: (data: VersionResponse) => void;
}

function useUpdateRequired({ onUpdateRequired }:Props) {
    const isIos = !(navigator.userAgent.match(/iPhone|iPad|iPod/i) === null);
    useEffect(() => {
        getVersion();
    }, []);

    useNativeListener('getVersion', (version: string) => {
        VersionApi.getVersion({
            appType: 'ORDER',
            osType: isIos ? 'IOS' : 'AOS',
            version,
        }).then((res) => {
            const { forceUpdate } = res;
            if (forceUpdate) {
                onUpdateRequired?.(res);
            }
        });
    }, [onUpdateRequired]);
}

export default useUpdateRequired;
